





















import { Prop, Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { SwScrollView } from '@sonicwall/unified-ui-framework/src/shared/sw-scroll-view';
import { SwTitlePane } from '@sonicwall/unified-ui-framework/src/shared/sw-title-pane';
import { envCongif } from '@/shared/env.config';
// import { InfoState } from '@/core';

const cssPrefix = 'termsAndConditionDialog';
@Component({
  components: {
    ...UUIFComponent,
    SwScrollView,
    SwTitlePane,
  },
})

export default class TermsAndConditionsDialog extends SwExtendedVue {
  @Prop()
  termsAndConditionModal: boolean;
  @Prop()
  tAndcObject: any;
  @Prop()
  termsandconditionsmessage: any;
  cssPrefix = cssPrefix;
  baseUrl = `${envCongif.apiGatewayHostUrl}/`;

  closeDialog(value:boolean = false) {
    this.$emit('closeTermsAndConditionDialog', value);
  }

  downloadSoftware() {
    this.$store.commit('startLoading');
    setTimeout(() => { this.$store.commit('stopLoading'); }, 1000);
    // User or free.
    const payload = { username:this.tAndcObject.username, swID:this.tAndcObject.swid, swGrpID: this.tAndcObject.swgroupid, isRNotes: this.tAndcObject.isRNotes, appName:'MSW', oemCode:'SNWL' };
    this.$store.dispatch(
      'DownloadCenterStoreModule/downloadSoftware', payload,
    )
    .then((resp: any) => {
      if (resp.operationStatus === 'NOK') {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
      } else {
        window.open(resp.content.downloadUrl);
      }
    })
    .catch((errorRes: any) => {
      console.error(errorRes.message);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }

  mounted() {
    const element = document.getElementById('tAndcElement');
    element!.innerHTML = this.termsandconditionsmessage;
  }

}
